import { Box } from '@grupoboticario/flora-react'
import { CrossCircleIcon, InformationCircleIcon } from '@grupoboticario/flora-react-icons'

const MESSAGE_COLORS: Record<string, string> = {
  error: '$statusErrorNonInteractiveEmphasis',
  info: '$nonInteractiveAuxiliar'
}

interface AlertMessageProps {
  type: 'error' | 'info'
  message: string
}

const AlertMessage = ({ type, message }: AlertMessageProps) => (
  <Box
    aria-live={type === 'error' ? 'assertive' : 'polite'}
    css={{
      alignItems: 'center',
      backgroundColor: '$backgroundTertiary',
      color: MESSAGE_COLORS[type] ?? MESSAGE_COLORS.info,
      display: 'flex',
      fontFamily: '$body',
      fontSize: '$1xl',
      justifyContent: 'center',
      marginTop: '$4',
      padding: '$8'
    }}
    role={type === 'error' ? 'alert' : 'status'}
  >
    {type === 'error' && <CrossCircleIcon aria-hidden="true" css={{ marginRight: '$2' }} />}
    {type === 'info' && <InformationCircleIcon aria-hidden="true" css={{ marginRight: '$2' }} />}
    {message}
  </Box>
)

export { AlertMessage }
